/**
 * Created by kz on 28.06.17.
 */
import * as api from '@api/participation'

export const all = ({commit}) => {
  commit('loading', true, {root: true})
  return api.getParticipations()
    .then(({data}) => {
      commit('receive', data)
      commit('loading', false, {root: true})
    })
}

export const get = ({commit}, id) => {
  commit('loading', true, {root: true})
  return api.getParticipation(id)
    .then(({data}) => {
      commit('current', data)
      commit('loading', false, {root: true})
    })
    .catch((error) => {
      commit('errorMessage', error.response.data.message, {root: true})
      commit('loading', false, {root: true})
      throw error
    })
}

export const answer = ({commit, state, dispatch}, questionnaire) => {
  commit('loading', true, {root: true})
  return api.answer(state.current._id, questionnaire)
    .then(() => {
      commit('successMessage', 'Анкета сохранена', {root: true})
      return dispatch('get', state.current._id)
    })
    .catch((error) => {
      commit('errorMessage', error.response.data.message, {root: true})
      commit('loading', false, {root: true})
    })
}

export const agree = ({commit, state, dispatch}, id) => {
  commit('loading', true, {root: true})
  return api.agree(id)
    .then(() => {
      return dispatch('all')
    })
    .catch(() => {
      commit('errorMessage', 'Ошибка согласия', {root: true})
      commit('loading', false, {root: true})
    })
}

export const saveBids = ({commit, state, dispatch}, bids) => {
  commit('loading', true, {root: true})
  return api.bids(state.current._id, bids)
    .then(() => {
      commit('successMessage', 'Ставки загружены', {root: true})
      return dispatch('get', state.current._id)
    })
    .catch(() => {
      commit('errorMessage', 'Ошибка загрузки ставок', {root: true})
      commit('loading', false, {root: true})
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/participation/actions.js